import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import ApiProvider from "../../../apiProvider.js";
import { Button, Container } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import LegalText from "./legalText.jsx";
import PDFViewer from "../../../Components/PDFViewer/PDFViewer.jsx";
import MobilePDFViewer from "../../../Components/PDFViewer/MobilePDFViewer.jsx";
import EmployeeLookup from "../../../Components/EmployeeLookup/EmployeeLookup.jsx";
import { isMobile } from "../../../mobileHelper.js";
import { useNavigate } from "react-router-dom";
import {
    CdsForm,
    CdsCheckboxField,
    CdsActionModal,
    useFormContext,
} from "clayco-component-library";
import * as yup from "yup";
import AddTaxStatement from "./add-tax-statement.jsx";
import * as Icon from "react-bootstrap-icons";

const TaxStatements = ({ currentLocation, setMenuOptions }) => {
    const { instance, accounts } = useMsal();
    const apiProvider = new ApiProvider(instance, accounts[0]);
    const [isCheckingConsent, setIsCheckingConsent] = useState(true);
    const [consentGiven, setConsentGiven] = useState(false);
    const consentText = "I consent";
    const revokeConsentText = `Revoke Consent to display Tax Forms online`;
    const [loading, setLoading] = useState(true);
    const [wTwos, setWTwos] = useState([]);
    const [displayWTwos, setDisplayWTwos] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState("");
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [isPayslipAdmin, setIsPayslipAdmin] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("We encountered an error");

    const [personMessage, setPersonMessage] = useState("My Tax Forms");
    const [fileForModal, setFileForModal] = useState("");
    const [showAdd, setShowAdd] = useState();
    const [documentIdForDeletion, setDocumentIdForDeletion] = useState("");
    const [documentTypeForDeletion, setDocTypeForDeletion] = useState();
    const [documentSubmitted, setDocumentSubmitted] = useState();


    useEffect(() => {
        if (accounts[0].idTokenClaims?.roles?.includes("PayslipAdmin")) {
            setIsPayslipAdmin(true);
        }

        async function CheckConsent() {
            setIsCheckingConsent(true);

            var consent = await apiProvider.Get(
                "Consent/Employee/CheckDigitalConsent"
            );
            if (!consent.error) {
                setConsentGiven(consent);

                if (consent === true) {
                    await getW2s();
                }
            } else {
                setError(true);
            }
            setIsCheckingConsent(false);
        }

        CheckConsent();
        setMenuOptions("TaxStatements");
    }, []);

    const handleAddTaxStatementSuccess = (documentSubmitted) => {
        setDocumentSubmitted(documentSubmitted);
        onEmployeeSelected(selectedEmployee);
    };

    const getW2s = async () => {
        setLoading(true);

        await apiProvider.Get("TaxStatement/Employee/All").then((result) => {
            if (!result.error) {
                if (result.length > 0) {
                    setError(false);
                } else {
                    setError(true);
                    setErrorMessage("0 Results");
                }
                setWTwos(result);
            } else {
                setError(true);
                setErrorMessage(
                    "An error occurred while trying to retrieve Form W2s"
                );
            };
        });

        setLoading(false);
    };

    const GetW2sByEmployee = async (employeeId) => {
         await apiProvider.Get(`TaxStatement/Employee/${employeeId}`).then((result) => {
            if (!result.error) {
                if (result.length > 0) {
                    setError(false);
                } else {
                    setError(true);
                    setErrorMessage("0 Results");
                }
                setWTwos(result);
            } else {
                setError(true);
                setErrorMessage(
                    "An error occurred while trying to retrieve Form W2s"
                );
            }
            setLoading(false);
        });
    }

    function getFileInfo(id, type) {
        setShowModal(true);
        setFileForModal(`TaxStatement/Employee/GetFile/${id}/${type}`);
    }

    const updateConsent = async (val) => {
        setIsCheckingConsent(true);
        let result = await apiProvider.Post(
            "Consent/Employee/UpdateDigitalConsent",
            { Value: val }
        );
        if (!result.error) {
            setConsentGiven(val);
            if (!val || val === false) {
                setWTwos([]);
            }
        } else {
            setError(true);
        }

        setIsCheckingConsent(false);
    };

    const handleUnselectFile = () => {
        //debugger;
        setFileForModal("");
    };

    const confirmDelete = (id, type) => {
        setDocumentIdForDeletion(id);
        setDocTypeForDeletion(type);
    };

    const deleteDocument = async () => {

        let url = '';
        if (documentTypeForDeletion === 0){
            url =`TaxStatement/${documentIdForDeletion}`
        }
        else {
            url = `TaxStatement/1095/${documentIdForDeletion}`
        }
        let response = await apiProvider.Delete(url);
        if (!response.error) {
            setDocumentIdForDeletion(null);
            onEmployeeSelected(selectedEmployee);
        }
    };

    const onEmployeeSelected = async (employee) => {
        setLoading(true);
        let response = null;
        if (employee) {
            setSelectedEmployee(employee);
            response = await GetW2sByEmployee(employee.id);
            setPersonMessage(`${employee.displayName}'s Tax Forms`);
        } else {
            response = await getW2s();
            setPersonMessage("My Tax Forms");
        }
    };
    const formSchema = yup.object().shape({
        payslipsEmail: yup.date().required("This date is required"),
    });

    return (
        <>
            <Container fluid className="w-100 tax-statements ">
                <CdsForm schema={formSchema}>
                    {isCheckingConsent ? (
                        <div className="spinner">
                            <Spinner></Spinner>
                            <p>Loading...</p>
                        </div>
                    ) : (
                        <div className="">
                            <h4>Tax Statements</h4>
                            <hr />

                            {consentGiven ? (
                                <div className="tax-statement-list">
                                    {isPayslipAdmin && (
                                        <div className="row">
                                            <div className="col col-6">
                                                <EmployeeLookup
                                                    label={'Find Employee'}
                                                    onEmployeeSelected={onEmployeeSelected}
                                                    formSchema={formSchema}
                                                ></EmployeeLookup>
                                            </div>
                                        </div>
                                    )}

                                    {selectedEmployee == null && (
                                        <div className="row mt-4">
                                            <div className="col col-12">
                                                <CdsCheckboxField
                                                    name="consentCheckbox"
                                                    label={revokeConsentText}
                                                    onChange={() => {
                                                        updateConsent(false);
                                                        setLoading(true);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className="row mt-3">
                                        <div className="col col-12">
                                            {isPayslipAdmin && (
                                                <>
                                                    {personMessage}
                                                    <button
                                                        className="btn btn-link cds-link p-0 pb-1 ps-1"
                                                        onClick={() => {
                                                            setShowAdd(true);
                                                        }}
                                                    >
                                                        Add Tax Statement
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row title-row">
                                        <div className="col col-12 col-xl-6">
                                            Tax Statements
                                        </div>
                                    </div>
                                    {loading && (
                                        <div className="row spinner-row">
                                            <div className="col col-12 col-xl-6 pt-3">
                                                <div className="spinner">
                                                    <Spinner></Spinner>
                                                    <p>Loading...</p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {Boolean(!loading && error) && (
                                        <div className="row error-row">
                                            <div className="col col-12 col-xl-6 p-3 text-center">
                                                {errorMessage}
                                            </div>
                                        </div>
                                    )}
                                    {Boolean(!loading && !error) && (
                                        <>
                                            {wTwos.map((wTwo, key) => (
                                                <div className="row result-row">
                                                    {isPayslipAdmin ? (
                                                        <>
                                                            <div className="col col-6 col-xl-3">
                                                                <button
                                                                    className="btn btn-link cds-link p-0"
                                                                    onClick={() =>
                                                                        getFileInfo(
                                                                            wTwo.identifier,
                                                                            wTwo.type
                                                                        )
                                                                    }
                                                                >
                                                                    {
                                                                        wTwo.reportingYear
                                                                    }{" "}
                                                                    {
                                                                        wTwo.stateWorked
                                                                    }
                                                                    { wTwo.type == 0 ? " W2" : " 1095"}
                                                                </button>
                                                            </div>
                                                            <div className="col col-6 col-xl-3">
                                                                <button
                                                                    className="btn btn-link cds-link p-0"
                                                                    onClick={() =>
                                                                        confirmDelete(
                                                                            wTwo.id,
                                                                            wTwo.type
                                                                        )
                                                                    }
                                                                >
                                                                    <Icon.Trash className="icon ms-5" />
                                                                </button>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="col col-12 col-xl-6">
                                                                <button
                                                                    className="btn btn-link cds-link p-0"
                                                                    onClick={() =>
                                                                        getFileInfo(
                                                                            wTwo.identifier,
                                                                            wTwo.type
                                                                        )
                                                                    }
                                                                >
                                                                    {
                                                                        wTwo.reportingYear
                                                                    }{" "}
                                                                    {
                                                                        wTwo.stateWorked
                                                                    }
                                                                    {wTwo.type == 0 ? " W2" : " 1095"}
                                                                </button>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            ))}
                                        </>
                                    )}

                                    <div className="row help-row mt-2">
                                        <div className="col col-12">
                                            <p>
                                                In the event you feel your Form
                                                W-2 or 1095-C is incorrect, contact{" "}
                                                <a href="mailto:deitersk@claycorp.com">
                                                    Kristen Deiters
                                                </a>{" "}
                                                (Payroll Manager) phone -{" "}
                                                <a href="tel:3145922238">
                                                    314.592.2238
                                                </a>{" "}
                                                or email{" "}
                                                <a href="payroll@Claycorp.com">
                                                    payroll@claycorp.com
                                                </a>{" "}
                                                immediately for modification and
                                                redistribution of a new Form
                                                W-2 or 1095-C.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className="row">
                                        <div className="col col-12">
                                            <LegalText />
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col col-12">
                                            <CdsCheckboxField
                                                name="consent-checkbox"
                                                label={consentText}
                                                onChange={() => {
                                                    updateConsent(true).then(
                                                        getW2s()
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                </CdsForm>

                {isMobile.any() ? (
                    <MobilePDFViewer
                        fileName={fileForModal}
                        setFileName={handleUnselectFile}
                    ></MobilePDFViewer>
                ) : (
                    <PDFViewer
                        fileName={fileForModal}
                        setFileName={handleUnselectFile}
                    ></PDFViewer>
                )}

                <CdsActionModal
                    show={documentIdForDeletion}
                    handleCloseClick={() => setDocumentIdForDeletion("")}
                    primaryButtonText="Delete"
                    primaryButtonAction={deleteDocument}
                    secondaryButtonText="Cancel"
                    secondaryButtonAction={() => setDocumentIdForDeletion("")}
                    disablePrimaryButton={false}
                >
                    <p className="text-center pt-3">
                        Are you sure you want to delete this tax statement?
                    </p>
                </CdsActionModal>

                <AddTaxStatement
                    show={showAdd}
                    setShow={setShowAdd}
                    selectedEmployee={selectedEmployee}
                    setDocumentSubmitted={handleAddTaxStatementSuccess}
                />
            </Container>
        </>
    );
};

export default TaxStatements;
